import { Dropdown, Menu, Space } from 'antd';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ArrowDownMenuIcon } from 'src/assets/icons';
import { DOMAIN_IAO } from 'src/constants/paths';
import { IMenuItem } from '.';

const MenuItem: React.FC<IMenuItem> = ({ label, path, subMenus }) => {
  // const { pathname } = useLocation();
  const userTheme = useSelector((state: any) => state.theme);

  const [isOpenDropdown, setIsOpenDropdown] = useState(false);

  let listSubMenu: ItemType[] = [];

  // const isActiveLink = !!subMenus?.find((subMenuItem, i) =>
  //   pathname.includes(subMenuItem.path ?? ''),
  // );

  const renderMenuItem = () => {
    if (subMenus) {
      listSubMenu = subMenus.map((subItem, i) => {
        const isOpenBlankTab = subItem.path.includes(DOMAIN_IAO ?? '');

        const renderLabel = () => {
          if (isOpenBlankTab) {
            return (
              <div
                onClick={() => {
                  window.location.replace(subItem.path ?? '');
                }}
              >
                {subItem.label}
              </div>
            );
          }

          return <Link to={subItem.path}>{subItem.label}</Link>;
        };

        return {
          key: i,
          label: renderLabel(),
        };
      });

      return (
        <Dropdown
          open={isOpenDropdown}
          onOpenChange={(open) => setIsOpenDropdown(open)}
          overlay={<Menu items={listSubMenu} />}
          overlayClassName={`dropdown ${userTheme}`}
          placement="bottom"
        >
          <Space>
            <span className="menu-item__label">{label}</span>
            <img src={ArrowDownMenuIcon} alt="" />
          </Space>
        </Dropdown>
      );
    }

    return (
      <div
        className="menu-item__label"
        onClick={() => {
          window.location.replace(path ?? '');
        }}
      >
        {label}
      </div>
    );
  };

  return (
    // <div className={`menu-item ${isActiveLink ? 'menu-item--active' : ''}`}>{renderMenuItem()}</div>
    <div className={`menu-item ${isOpenDropdown ? 'menu-item--active' : ''}`}>
      {renderMenuItem()}
    </div>
  );
};

export default MenuItem;
